import { render, staticRenderFns } from "./DashboardRN.vue?vue&type=template&id=2ae4e026&scoped=true&"
import script from "./DashboardRN.vue?vue&type=script&lang=js&"
export * from "./DashboardRN.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRN.vue?vue&type=style&index=0&id=2ae4e026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae4e026",
  null
  
)

export default component.exports